export class AttachmentFilterParameters {
  public readonly searchString?: string;
  public readonly minCreatedDate?: string;
  public readonly maxCreatedDate?: string;

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.searchString) searchParams.append(
      "searchString",
      this.searchString
    );
    if (this.minCreatedDate) searchParams.append(
      "minCreatedDate",
      this.minCreatedDate
    );
    if (this.maxCreatedDate) searchParams.append(
      "maxCreatedDate",
      this.maxCreatedDate
    );
    return searchParams;
  }

  public constructor(
    searchString?: string,
    minCreatedDate?: string,
    maxCreatedDate?: string
  ) {
    this.searchString = searchString;
    this.minCreatedDate = minCreatedDate;
    this.maxCreatedDate = maxCreatedDate;
  }

  public isEqualTo(other: AttachmentFilterParameters): boolean {
    if (!other) return false;
    return this.searchString === other.searchString &&
      this.minCreatedDate === other.minCreatedDate &&
      this.maxCreatedDate === other.maxCreatedDate;
  }
}

export default class AttachmentParameters {
  public readonly filterParameters: AttachmentFilterParameters;

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.filterParameters.searchParams
    ]);

  }

  public constructor(
    filterParameters: AttachmentFilterParameters
  ) {
    this.filterParameters = filterParameters;
  }

  public isEqualTo(other: AttachmentParameters | undefined): boolean {
    if (!other) {
      return false;
    }

    return this.filterParameters.isEqualTo(other.filterParameters);
  }
}
